import React, { lazy, Suspense } from 'react'
import Preloader from './Preloader'

const Content = lazy(() => import('./Content'))

function HistoryPage() {
    return (
        <Suspense fallback={<Preloader />}>
            <Content />
        </Suspense>
    )
}

export default HistoryPage
